module.exports = __webpack_public_path__ + "static/2-Entrance-Drop-Off-50bd2abcca3d625389cb40f2792d8a03.webp";